<template>
  <div class="flex flex-col">
    <!-- {{ weekdayDiffs }} -->
    <div class="flex flex-row p-2 gap-4">
      <div class="flex flex-row items-center justify-center px-4 rounded-full bg-white h-12 !shadow">
        <div class="relative px-2 justify-items-start"
          v-for="(weekdayInitialObj, index) of filteredWeekdayInitials"
          :key="`${weekdayInitialObj.letter}.${index}`">
          <div v-if="weekdayDiffs[weekdayInitialObj.letter]">
            <div class="absolute -z-10 block -bottom-4 left-0 p-4 rounded-lg shadow w-full"
              :class="{
                'bg-green-300' : weekdayDiffs[weekdayInitialObj.letter] === 'add',
                'bg-red-300' : weekdayDiffs[weekdayInitialObj.letter] === 'remove',
                'bg-orange-300' : weekdayDiffs[weekdayInitialObj.letter] === 'change',
              }">
              <div class="h-4 rounded-full mt-2">
              </div>
            </div>
          </div>
          <button
            class="focus:outline-none font-bold text-white rounded-full h-10 w-10 flex items-center justify-center"
            :class="{
              'ring-2 ring-gray-700': index === currentWeekdayIndex,
            }"
            :style="{
              background: directionGradient(getDirection(weekdayInitialObj.code)),
            }"
            type="button"
            @click="onSelectWeekday(index)">
            {{ weekdayInitialObj.display }}
            <!-- <div class="block px-2 absolute justify-center flex flex-row w-full -bottom-2 left-0 right-0 bg-green-200">
              <div class="grow w-20">
                TEST
              </div>
            </div> -->
          </button>
        </div>
      </div>
      <Button
        class="rounded-full"
        color="blue"
        size="md"
        @click="toggleExpandAllDays">
        {{ toggleExpandDisplay }}
      </Button>
    </div>
    <div v-show="!expandAllDays"
      class="mt-4">
      <!-- <div>Single Day Diff:</div><div class="text-green-500">{{ scheduleWeekdayDataDiff }}</div> -->
      <HighlightChange class="p-2"
        :changeType="highlightWholeDay(scheduleWeekdayDataDiff)">
        <SingleWeekday
          :weekdayCode="filteredWeekdayInitials[currentWeekdayIndex].code"
          :scheduleData="scheduleWeekdayData"
          :scheduleDataDiff="scheduleWeekdayDataDiff"
        />
      </HighlightChange>
    </div>
    <div v-show="expandAllDays"
      class="mt-4">
      <div
        v-for="([weekdayScheduleData, weekdayScheduleDataDiff], index) in allWeekdaysOrdered"
        :key="index">
        <div class="flex flex-col">
          <!-- <span class="text-gray-500">{{ weekdayScheduleData }}</span> -->
          <!-- <span class="text-green-500">{{ weekdayScheduleDataDiff }}</span> -->
        </div>
        <HighlightChange class="p-2"
          :changeType="highlightWholeDay(weekdayScheduleDataDiff)">
          <SingleWeekday
            :weekdayCode="weekdayScheduleData.weekday"
            :scheduleData="weekdayScheduleData"
            :scheduleDataDiff="weekdayScheduleDataDiff"
          />
        </HighlightChange>
      </div>
      <div v-if="allWeekdaysOrdered.length === 0">
        <div class="bg-white !shadow rounded-md py-2 px-3 text-lg mb-40">
          <div class="text-xl m-3">No Trips For Schedule</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, reduce } from 'lodash'
import scheduleUtil from '../../../services/utils/schedule.js'

import Button from '../../Button.vue'
import HighlightChange from '../utilities/HighlightChange.vue'

import SingleWeekday from './SingleWeekday.vue'

const WEEKDAY_INITIALS = [
  { display: 'Su', letter: 'N', code: 'sun', },
  { display: 'M', letter: 'M', code: 'mon', },
  { display: 'T', letter: 'T', code: 'tue', },
  { display: 'W', letter: 'W', code: 'wed', },
  { display: 'R', letter: 'R', code: 'thu', },
  { display: 'F', letter: 'F', code: 'fri', },
  { display: 'Sa', letter: 'S', code: 'sat', },
]

export default {
  components: {
    Button,
    HighlightChange,
    SingleWeekday,
  },
  props: {
    defaultExpandAllDays: {
      type: Boolean,
      default: false,
    },
    scheduleData: {
      type: Object,
      default: undefined,
    },
    scheduleDataDiff: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      expandAllDays: false,
      currentWeekdayIndex: this.getWeekdayIndex(),
      weekdayLetterCodes: ['N', 'M', 'T', 'W', 'R', 'F', 'S'],
      weekdaySlots: [],
    }
  },
  methods: {
    any(iterator) {
      for (const value of iterator) {
        if (value) {
          return true
        }
      }
      return false
    },
    toggleExpandAllDays() {
      this.expandAllDays = !this.expandAllDays
    },
    getWeekdayIndex() {
      const dayInt = new Date().getDay()
      return dayInt
    },
    assignScheduleData(weekdays) {
      if (weekdays === undefined) {
        let weekdayInitials = cloneDeep(WEEKDAY_INITIALS)
        weekdayInitials.shift()
        weekdayInitials.pop()
        return weekdayInitials
      }

      let weekdayInitials = cloneDeep(WEEKDAY_INITIALS)

      var satIndex = weekdays.findIndex(elem => elem.weekday === 'sat')
      var sunIndex = weekdays.findIndex(elem => elem.weekday === 'sun')
      if (satIndex < 0 && sunIndex < 0) {
        weekdayInitials.shift()
        weekdayInitials.pop()
        if (this.currentWeekdayIndex >= weekdayInitials.length) {
          this.currentWeekdayIndex = weekdayInitials.length - 1
        }
      }
      return weekdayInitials
    },
    onSelectWeekday(index) {
      this.currentWeekdayIndex = index
    },
    getDirection(code) {
      if (this.scheduleData?.schedule?.weekdays === undefined) {
        return ''
      }
      let weekday = this.scheduleData.schedule.weekdays.find(elem => elem.weekday === code)
      if (weekday === undefined) {
        return ''
      }
      let tripTypes = weekday.trips.map((trip) => trip.type)
      if (tripTypes.includes('inbound') && tripTypes.includes('outbound')) {
        return 'B'
      } else if (tripTypes.includes('inbound')) {
        return 'I'
      } else if (tripTypes.includes('outbound')) {
        return 'O'
      } else if (tripTypes.includes('shuttle')) {
        return 'S'
      }
      return ''
    },
    directionGradient(direction) {
      switch (direction) {
        case 'I':
          return 'linear-gradient(to right, #0080d4 50%, rgb(200, 200, 200) 50%)'; // Left blue, right grey
        case 'O':
          return 'linear-gradient(to right, rgb(200, 200, 200) 50%, #0080d4 50%)'; // Left grey, right blue
        case 'B':
          return '#0080d4'; // Full blue
        case 'S':
          return 'linear-gradient(to bottom, rgb(200, 200, 200) 50%, rgb(241, 111, 66) 50%)'; // top gray, bottom orange
        default:
          return 'rgb(200, 200, 200)'; // Full grey
      }
    },
    highlightWholeDay(diffObj) {
      let retVal = scheduleUtil.mapDiffObject(diffObj)
      if (retVal === 'add' || retVal === 'remove') {
        return retVal
      }
      else {
        return undefined
      }
    },
  },
  mounted() {
    this.expandAllDays = this.defaultExpandAllDays
  },
  computed: {
    weekdayDisplay() {
      let mapIndex = [
        undefined,
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ]

      return mapIndex[this.currentWeekdayIndex]
    },
    filteredWeekdayInitials() {
      return this.assignScheduleData(this.scheduleData?.schedule?.weekdays)
    },
    weekdayDiffs() {
      return reduce(this.weekdayLetterCodes, (accum, curr) => {
        accum[curr] = this.scheduleDataDiff?.schedule?.recurrence?._diff?.__change.includes(curr)
        if (accum[curr]) {
          let weekdayData = WEEKDAY_INITIALS.find(winit => winit.letter === curr)
          if (weekdayData) {
            accum[curr] = scheduleUtil.mapDiffObject(this.scheduleDataDiff?.schedule?.weekdays[`0.${weekdayData.code}`])
          }
        }
        return accum
      }, {})
      // return this.weekdayLetterCodes.map(
      //   letter => this.scheduleDataDiff?.schedule?.recurrence?._diff?.__change.includes(letter)
      // )
    },
    toggleExpandDisplay() {
      return (this.expandAllDays) ? "Collapse Days" : "View All"
    },
    allWeekdaysOrdered() {
      if (!(this.scheduleData?.schedule?.weekdays)) {
        return []
      }
      let finalAccum = reduce(WEEKDAY_INITIALS, (accum, winit) => {
        accum[`0.${winit.code}`] = {
          use: false,
          weekday: winit.code,
        }
        return accum
      }, {})
      for (const weekday of this.scheduleData.schedule.weekdays) {
        finalAccum[`0.${weekday.weekday}`].use = true
        finalAccum[`0.${weekday.weekday}`].data = weekday
      }
      for (const weekdayCode in this.scheduleDataDiff?.schedule?.weekdays) {
        if (weekdayCode === '_keys') {
          continue
        }
        let weekdayDiff = this.scheduleDataDiff?.schedule?.weekdays[weekdayCode]
        finalAccum[weekdayCode].use = true
        finalAccum[weekdayCode].diff = weekdayDiff
      }

      let allWeekdaysData = []
      for (const winit of WEEKDAY_INITIALS) {
        let index = `0.${winit.code}`
        if (finalAccum[index].use) {
          if (finalAccum[index].data) {
            allWeekdaysData.push([finalAccum[index].data, finalAccum[index].diff])
          }
          else {
            allWeekdaysData.push([{ weekday: finalAccum[index].weekday }, finalAccum[index].diff])
          }
        }
      }
      return allWeekdaysData
    },
    scheduleWeekdayData() {
      if (!this.filteredWeekdayInitials[this.currentWeekdayIndex]) {
        return undefined
      }
      let weekdayCode = this.filteredWeekdayInitials[this.currentWeekdayIndex].code
      return this.scheduleData?.schedule?.weekdays.find(elem => elem.weekday === weekdayCode)
    },
    scheduleWeekdayDataDiff() {
      if (!this.filteredWeekdayInitials[this.currentWeekdayIndex].code) {
        return undefined
      }
      let weekdayCode = this.filteredWeekdayInitials[this.currentWeekdayIndex].code
      return this.scheduleDataDiff?.schedule?.weekdays[`0.${weekdayCode}`]
    },
  },
}
</script>
